module.exports = __webpack_public_path__ + "img/billing_report_bill.5fa255cc.svg";